import { inject, Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RecaptchaService {
  private readonly recaptchaV3Service = inject(ReCaptchaV3Service);

  executeBookingRequest(): Promise<string> {
    const siteKey = environment.recaptchaSiteKey?.trim();

    if (!siteKey) {
      return Promise.reject(
        new Error('reCAPTCHA site key is not configured. Set recaptchaSiteKey in the active environment file.')
      );
    }

    return this.recaptchaV3Service.executeAsPromise(siteKey, 'booking_request');
  }

  executeSiteUserMessageRequest(): Promise<string> {
    const siteKey = environment.recaptchaSiteKey?.trim();

    if (!siteKey) {
      return Promise.reject(
        new Error('reCAPTCHA site key is not configured. Set recaptchaSiteKey in the active environment file.')
      );
    }

    return this.recaptchaV3Service.executeAsPromise(siteKey, 'site_user_message');
  }
}
